import React from "react";

export default function GameOver({history}) {
  return (
    <div className='game-selector-container' style={{height:'100vh' }}>
      <div className='game-over-card'>
        <h1>FIN DEL JUEGO</h1>
        <h3>Gracias por Jugar</h3>
        <p>
           Te esperamos pronto
        </p>
        <button onClick={()=>history.push('/')}>JUGAR DE NUEVO</button>
      </div>
    </div>
  );
}
